import React from 'react';

import {
    Layout, Button, Alert, Form, Row, Col, Input, Icon, Select, Table, Modal
} from 'antd';

import '../App.css';
import Axios from 'axios';
import config from '.././config.json';
import $ from 'jquery';
import base64_arraybuffer from 'base64-arraybuffer';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
const keyvalue = 1;
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};



class MergeStudents extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            login: true,
            data: [],
            selectedRowKeys: [],
            selectedRows: [],
            disableButton: true,
        };
    }

    /**
     * This code runs after a component is rendered.
     * As a result this is where we retrieve our data from the server.
     */
    componentWillMount() {
        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });
    }

    /**
    * From submit event
    */
    handleMerge = (e) => {

        console.log(this.state.selectedRows);
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/students/mergestudents`,
            data: { students: this.state.selectedRows } 
        })
            .done((result) => {
                console.log(result);
                Modal.success({
                    title: 'Merge successful!',
                });

            })
            .fail((jqXhr) => {
                Modal.error({
                    title: 'Merge unsuccessful!',
                });
            });
    }


    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log(values);
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/students/searchlastname`,
                    data: { lastname: values.lname }
                })
                    .done((result) => {
                        console.log(result);
                        this.setState({
                            data: result,
                        });
                    })
                    .fail((jqXhr) => {
                        console.log('failed to get category');
                    });

            }
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {

        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        if (selectedRows.length <= 2) {
            console.log("here");
            this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows
            });
            if (selectedRows.length == 2)
            {
                this.setState({
                    disableButton: false
                });
            }
            else {
                this.setState({
                    disableButton: true
                });
            }
        }
        else {
            Modal.error({
                title: 'Error',
                content: 'Only two student can be merged at a time.',
            });
        
        }
    };
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const Columns = [
            {
                title: 'First Name',
                dataIndex: 'FirstName',
            },
            {
                title: 'Middle I',
                dataIndex: 'MiddleInitial',
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName',
            },
            {
                title: 'Email',
                dataIndex: 'Email',
            },
            {
                title: 'Tech ID',
                dataIndex: 'TechID',
            },
            {
                title: 'Address',
                dataIndex: 'Address',
                render: (text, record, index) => {
                    var add = 'Not Available';
                    if (record.StreetAddress) {
                        add = record.StreetAddress + ', ' + record.City + ' (' + record.State + ')';
                    }
                    return (
                        <div>{add}</div>
                    );
                },

            },
            {
                title: 'Employer',
                dataIndex: 'CompanyName',
                render: (text, record, index) => {
                    let emp = 'Not Available';
                    if (record.CompanyName) {
                        emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                    }
                    return (
                        <div>{emp}</div>
                    );
                },
            },

        ];
        const { selectedRowKeys, selectedRows } = this.state;
        const rowSelection = {
            selectedRowKeys,
            selectedRows,
            onChange: this.onSelectChange,
        };
        return (
            <div>
                {this.state.login ?
                    <div>
                        <h1>Merge Students</h1>
                            <hr/>
                        <div className="container" >
                            <div style={{ 'width': '400px' }} className="panel panel-default">
                                <div className="panel-heading">
                                <h2>Search Criteria</h2>
                                </div>
                                <br />
                        <Form onSubmit={this.handleSearch}>
                            <FormItem
                                {...formItemLayout}
                                label="Last Name"
                            >
                                {getFieldDecorator('lname', {
                                    rules: [{
                                        required: true, message: 'Required',
                                    }],
                                })(<Input placeholder="Last Name" />
                                    )}
                            </FormItem>

                            <Row>
                                <Col span={48} style={{ textAlign: 'left' }}>
                                    <center><button type="submit" className="btn btn-default">Submit</button></center>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                            </div>
                         </div>
                        <Table rowKey="StudentId" bordered columns={Columns}
                            rowSelection={rowSelection}
                            dataSource={this.state.data}
                            scroll={{ x: 900 }}
                        />
                    <button onClick={() => { this.handleMerge() }} style={{ margin: 5, float: 'right' }} className="btn btn-default" disabled={this.state.disableButton}>Merge</button>
                    </div>
                    : <Redirect to="/login" replace />
                }
            </div>
           
        );
    }

}

const WrappedMergeStudent = Form.create()(MergeStudents);

export default WrappedMergeStudent;


// WEBPACK FOOTER //
// ./src/Admin/MergeStudents.js